import { BeyondTheRoom } from "./sections/BeyondTheRoom.js";
import { DemoSection } from "./sections/DemoSection.js";
import { Faq } from "./sections/Faq.js";
import { Footer } from "./sections/Footer.js";
import { Hero } from "./sections/Hero.js";
import { Nav } from "./sections/Nav.js";
import { Organizers } from "./sections/Organizers.js";
import { PrivacyDialog } from "./sections/PrivacyDialog.js";
import { PromiseStrip } from "./sections/PromiseStrip.js";
import { Walkthrough } from "./sections/Walkthrough.js";

/**
 * One long-scroll page, anchor-navigable. Every section is its own small file (`src/sections/`)
 * rather than one large component, so a copy change touches one file and one review.
 *
 * GH-894 replaced GH-890's original one-page layout (hero / proof band / pillars / how-it-works /
 * who-it's-for / CTA band) with an approved external visual design: a hero with a donor-app +
 * organizer-dashboard mockup, a three-step donor walkthrough, organizer tabs, a "beyond the room"
 * feature grid, an FAQ, and a real lead-capture form (`DemoSection`, wired to
 * `POST /v1/public/sales-leads`).
 */
export function App() {
  return (
    <>
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <Nav />
      <main id="main">
        <Hero />
        <PromiseStrip />
        <Walkthrough />
        <Organizers />
        <BeyondTheRoom />
        <Faq />
        <DemoSection />
      </main>
      <Footer />
      <PrivacyDialog />
    </>
  );
}
